<h2 class="h3 mb-3">{{ prefix + '-betaal-overzicht-titel' | fromDictionary }}</h2>
<dl class="dl-list cart-totals-list">
  <div class="dl-list__row cart-totals-list__row" *ngIf="cart.cost?.subtotalAmount?.amount">
    <dt>{{ prefix + '-betaal-overzicht-subtotaal' | fromDictionary }}</dt>
    <dd class="text-end">
      <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading === true"></app-icon>
      <span *ngIf="cartLoading === false">
        {{ cart.cost.subtotalAmount.amount | currency : cart.cost.subtotalAmount.currencyCode }}
      </span>
    </dd>
  </div>
  <div class="dl-list__row cart-totals-list__row" *ngFor="let group of cart.deliveryGroups">
    <dt>{{ group.selectedDeliveryOption.title }}</dt>
    <dd class="text-end">
      <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading === true"></app-icon>
      <span *ngIf="cartLoading === false">
        <ng-container *ngIf="parseFloat(group.selectedDeliveryOption.estimatedCost.amount) !== 0">
          {{ group.selectedDeliveryOption.estimatedCost.amount | currency : group.selectedDeliveryOption.estimatedCost.currencyCode }}
        </ng-container>
        <ng-container *ngIf="parseFloat(group.selectedDeliveryOption.estimatedCost.amount) === 0">
          {{ 'label-gratis' | fromDictionary }}
        </ng-container>
      </span>
    </dd>
  </div>
</dl>

<ng-content></ng-content>

<hr class="mb-2" />

<!-- <dl class="dl-list cart-totals-list">
  <div class="dl-list__row cart-totals-list__row">
    <dt>
      {{ prefix + '-betaal-overzicht-totaal-excl' | fromDictionary }}
      <span class="ps-1 text-muted type-body-xs">{{ prefix + '-betaal-overzicht-totaal-excl-suffix' | fromDictionary }}</span>
    </dt>

    <dd>
      <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading"></app-icon>
      <em *ngIf="cartLoading !== true">
        {{ cart.cost.subtotalAmount.amount | currency: cart.cost.subtotalAmount.currencyCode }}
      </em>
    </dd>
  </div>
</dl> -->
<ng-container *ngIf="cart.cost.totalTaxAmount?.amount > 0">
  <dl class="dl-list cart-totals-list">
    <!-- discount row -->
    <!--<div class="dl-list__row cart-totals-list__row">
      <dt>
        {{ prefix + '-betaal-overzicht-korting' | fromDictionary }}
      </dt>

      <dd>
        <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading"></app-icon>
        <em class="discount-label" *ngIf="cartLoading !== true">
          {{ cart.discountCodes[0].code }}
        </em>
      </dd>
    </div>-->

    <!-- btw -->
    <div class="dl-list__row cart-totals-list__row">
      <dt>
        {{ prefix + '-betaal-overzicht-btw' | fromDictionary }}
      </dt>

      <dd>
        <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading"></app-icon>
        <em *ngIf="cartLoading !== true">
          {{ cart.cost.totalTaxAmount.amount | currency : cart.cost.totalTaxAmount.currencyCode }}
        </em>
      </dd>
    </div>
  </dl>
  <ng-container *ngIf="customer">
    <ng-container *ngIf="customerLoaded === true">
      <app-alert class="d-block mb-3" [status]="'type--info'" *ngIf="hasVatNumber">
        {{ 'btw-nummer-ingevuld-controle-alert-titel' | fromDictionary }}
        <a [routerLink]="['/account/bewerken']" [queryParams]="{ returnUrl: '/cart' }">
          {{ 'btw-nummer-ingevuld-controle-alert-linktekst' | fromDictionary }}
        </a>
      </app-alert>
    </ng-container>
  </ng-container>
</ng-container>
<dl class="dl-list cart-totals-list">
  <div class="dl-list__row cart-totals-list__row">
    <dt>
      {{ prefix + '-betaal-overzicht-totaal-incl' | fromDictionary }}
      <span class="ps-1 text-muted type-body-xs">{{ prefix + '-betaal-overzicht-totaal-incl-suffix' | fromDictionary }}</span>
    </dt>

    <dd>
      <app-icon class="anim--spinning" anchor="icon-loader" *ngIf="cartLoading"></app-icon>
      <em class="h3" *ngIf="cartLoading === false">
        {{ cart.cost.totalAmount.amount | currency : cart.cost.totalAmount.currencyCode }}
      </em>
    </dd>
  </div>
</dl>
<div class="mt-2 mb-4">
  <!-- <ng-container *ngIf="customerLoaded === true"> -->
  <ng-container *ngIf="customer; else noCustomerMessages">
    <app-alert
      class="d-block mb-3"
      [title]="'btw-nummer-niet-ingevuld-alert-titel' | fromDictionary"
      [status]="'type--info'"
      *ngIf="!hasVatNumber"
    >
      <p class="my-2">{{ 'btw-nummer-niet-ingevuld-alert-tekst' | fromDictionary }}</p>
      <a class="button button--light button--sm mt-2" [routerLink]="['/account/bewerken']" [queryParams]="{ returnUrl: '/cart' }">
        <span>{{ 'btw-nummer-niet-ingevuld-alert-knoptekst' | fromDictionary }}</span>
      </a>
    </app-alert>
  </ng-container>
  <ng-template #noCustomerMessages>
    <app-alert
      class="d-block mb-3"
      [message]="'btw-nummer-niet-ingevuld-geen-profiel-alert-tekst' | fromDictionary"
      [status]="'type--info'"
    >
      <a class="button button--light button--sm mt-2" [routerLink]="['/auth/inloggen']" [queryParams]="{ returnUrl: '/cart' }">
        <span>{{ 'btw-nummer-niet-ingevuld-geen-profiel-alert-knoptekst' | fromDictionary }}</span>
      </a>
    </app-alert>
  </ng-template>
  <!-- </ng-container> -->

  <app-tax-exemption-alert *ngIf="exemptionsChecked && !exemptionsValid" (proceed)="checkout(true)"></app-tax-exemption-alert>
  <!-- <p class="type-body-xs">Belasting inbegrepen en verzendkosten worden berekend bij de checkout</p> -->
  <button
    (click)="checkout()"
    class="button button--secondary w-100 w-md-auto"
    [disabled]="cartLoading || exemptionsChecking || (exemptionsChecked && !exemptionsValid)"
  >
    {{ prefix + '-betaal-overzicht-knoptekst' | fromDictionary }}
  </button>
</div>
<p class="type-body-xs">{{ prefix + '-actiebalk-tekst' | fromDictionary }}</p>
